import { Box, Grid } from "@mui/material";
import { useState } from "react";
import Flex from "@/components/Flex";
import StyledDialog from "@/components/StyledDialog";
import Text from "@/components/Text";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import type { DisclosureHost } from "@/hooks/use-disclosure";
import {
  ADD_PATIENT_OPTIONS,
  ADD_PATIENT_TILE_COLUMNS,
  NAV_BAR_LABELS,
  NAV_BAR_LAYOUT,
} from "../nav-bar-constant";
import type { AddPatientSource } from "../nav-bar-types";

export interface NavAddPatientModalProps {
  disclosureHost: DisclosureHost;
  onNextClick: (source: AddPatientSource | null) => void;
}

const NavAddPatientModal = ({
  disclosureHost,
  onNextClick,
}: NavAddPatientModalProps) => {
  const [selectedSource, setSelectedSource] = useState<AddPatientSource | null>(
    null
  );

  const handleClose = () => {
    disclosureHost.close();
    setSelectedSource(null);
  };

  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle={NAV_BAR_LABELS.ADD_PATIENT_TITLE}
      onClose={handleClose}
      dialogAction={
        <Flex gap={2}>
          <StyledButtonV2
            label={NAV_BAR_LABELS.ADD_PATIENT_NEXT}
            sx={{ width: NAV_BAR_LAYOUT.ADD_PATIENT_NEXT_WIDTH }}
            variant="contained"
            disabled={!selectedSource}
            onClick={() => onNextClick(selectedSource)}
          />
        </Flex>
      }
    >
      <Box
        sx={{
          width: NAV_BAR_LAYOUT.ADD_PATIENT_BODY_WIDTH,
          height: NAV_BAR_LAYOUT.ADD_PATIENT_BODY_HEIGHT,
          mt: NAV_BAR_LAYOUT.ADD_PATIENT_BODY_TOP_GAP,
        }}
      >
        <Grid container spacing={3}>
          {ADD_PATIENT_OPTIONS.map((option) => {
            const isSelected = option.source === selectedSource;
            return (
              <Grid
                key={option.source}
                sx={{ cursor: "pointer" }}
                onClick={() => setSelectedSource(option.source)}
                size={ADD_PATIENT_TILE_COLUMNS}
              >
                <img
                  src={isSelected ? option.activeIcon : option.inactiveIcon}
                  alt=""
                />
                <Text
                  px={4}
                  mt={1.25}
                  textAlign="center"
                  fontWeight={isSelected ? "medium" : "normal"}
                >
                  {option.label}
                </Text>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default NavAddPatientModal;
